import { Component, OnInit, inject } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from '@uoa/auth';
import { Router, RouterLink } from '@angular/router';
import { isPhoneNumberFeatureEnabled } from 'src/app/core/phone-number-feature';
import { APP_ROUTE_PATTERNS } from 'src/app/core/route-paths';

interface HelpPageRoute {
  path: string;
  title: string;
}

interface HelpParameterizedRoute {
  pathPattern: string;
  isFeatureGated?: boolean;
}

@Component({
  selector: 'app-home',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: true,
  imports: [RouterLink],
})
export class HelpComponent implements OnInit {
  private router = inject(Router);
  private loginService = inject(LoginService);
  readonly isPhoneNumberFeatureEnabled = isPhoneNumberFeatureEnabled;
  readonly supplementalPageRoutes: HelpPageRoute[] = this.buildSupplementalPageRoutes();
  readonly parameterizedRoutes: HelpParameterizedRoute[] = this.buildParameterizedRoutes();

  ngOnInit() {
    of(null)
      .pipe(
        map(async () => {
          // Console out current logged-in user
          const user = await this.loginService.getUserInfo();
          const isAuthenticated = await this.loginService.isAuthenticated();
          if (!user) {
            await this.loginService.doLogin(this.router.url);
          }
          console.log('Current logged in user: ', user, JSON.stringify(user), isAuthenticated);
        }),
      )
      .subscribe();
  }

  private buildSupplementalPageRoutes(): HelpPageRoute[] {
    const routes: HelpPageRoute[] = [{ path: APP_ROUTE_PATTERNS.home, title: 'Home' }];

    if (this.isPhoneNumberFeatureEnabled) {
      routes.push({ path: APP_ROUTE_PATTERNS.phoneNumbersCreate, title: 'Create Blocked Number' });
    }

    return routes;
  }

  private buildParameterizedRoutes(): HelpParameterizedRoute[] {
    const routes: HelpParameterizedRoute[] = [{ pathPattern: APP_ROUTE_PATTERNS.promptsEdit }, { pathPattern: APP_ROUTE_PATTERNS.error }];

    if (this.isPhoneNumberFeatureEnabled) {
      routes.push({ pathPattern: APP_ROUTE_PATTERNS.phoneNumbersEdit, isFeatureGated: true });
    }

    return routes;
  }
}
